/* Non-Candidates Docs Form */
window.NCandidatesDocsForm = function (scope, Upload, userPermissions, userServices, authorityToRecruitDataService, onBoardingService) {

    var _formName = 'ncandidates-docs-form';
    var _formSelector = '.'+_formName;
    var self = this;
    var _protected = BaseForm.call(self, _formName, scope);

    var events = {
        "delete-document": []
    };

    self.onDeleteDocument = function(handler) {
        events["delete-document"].push(handler);
    };

    var trigger = function(eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function(handler){
            handler(param1, param2, param3, param4);
        });
    }

    //errors
    self.data = {};
    self.data.errors = {};
    self.OBIdObj = null;
    self.data.newDocs = [];
    self.canEditOffer = false;
    self.canEditOfferDescription = false;


    self.DOCUMENT_TYPE = OnBoardingAPI.DOCUMENT_TYPE;

    //no data loading is required yet
    self.load = function (OBIdObj) {
        if (OBIdObj) {
            var promises = {};
            promises['isATRServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ATR, OBIdObj.brand_id);
            promises['policyParser'] = userPermissions.getBrandPolicy(OBIdObj.brand_id);
            promises['onBoardingBrandSettings'] = OnBoardingAPI.getOnboardingBrandSettings(OBIdObj.brand_id);

            $q.all(promises)
                .then(function (result) {
                    var policyParser = result['policyParser'];
                    policyParser = policyParser.position(OBIdObj.position.position_type.code, OBIdObj.position.code);
                    self.OBIdObj = OBIdObj;
                    self.data.hiringDate = OBIdObj.start_date? moment(OBIdObj.start_date).format('MM-DD-YYYY') : null;
                    self.canEditOffer = policyParser.has(userPermissions.PERMISSIONS.MANAGE_DOCS_OFFERS);
                    self.canEditOfferDescription = policyParser.has(userPermissions.PERMISSIONS.MANAGE_DOCS_OFFERS_WITH_EDIT_DESCRIPTION);
                    self.isATRServiceEnabled = result['isATRServiceEnabled'];

                    var innerPromises = {};

                    if (self.isATRServiceEnabled) {
                        innerPromises['atrSettings'] = authorityToRecruitDataService.getATRSettings(OBIdObj.brand_id);
                    }

                    self.excludeOfferColumn = result['onBoardingBrandSettings'].exclude_offer_column;

                    var category = null;

                    if (self.excludeOfferColumn) {
                        category = 'ON_BOARDING,GFE';
                    }
                    if (self.OBIdObj?.action?.id) {
                        category = 'BRAND_CUSTOM';
                    }
                    innerPromises['docs'] = onBoardingService.listDocuments(null, self.OBIdObj.id, category, null, null, true, undefined, self.OBIdObj?.action?.id);

                    $q.all(innerPromises)
                        .then(function (innerResult) {

                                var spliceDocument = function (docCodes) {
                                    for (var i in self.documents) {
                                        if (docCodes.indexOf(self.documents[i].code) > -1) {
                                            self.documents.splice(i, 1);
                                        }
                                    }
                                };

                                var atrSettings = innerResult['atrSettings'];
                                var isAtrRequired = false;

                                if (self.isATRServiceEnabled && (atrSettings.atr_type === 'BNB_WORKDAY') && OBIdObj.position) {
                                    isAtrRequired = authorityToRecruitDataService.isPositionEligibleForATRSync(atrSettings, OBIdObj.position['code']);
                                }

                                self.documents = innerResult['docs'];

                                if (!self.canEditOffer || !self.canEditOfferDescription || isAtrRequired) {
                                    spliceDocument([self.DOCUMENT_TYPE.OFFER]);
                                }
                                let documentsGroup = [];
                                if (self.OBIdObj?.action?.id) {
                                    self.documents.filter(document => {
                                        if (document.type === "GROUP") {
                                            documentsGroup = documentsGroup.concat(document.group);
                                        }
                                    });
                                }

                                self.documents = self.documents.filter(function (document) {
                                    return document.type === "DOCUMENT";
                                });

                                if (self.OBIdObj?.action?.id) {
                                    self.documents.forEach((documents) => {
                                        documents.Documents = documents?.Documents?.filter((document) => {
                                            return document.document_lookup?.subcategory.id === self.OBIdObj?.action?.id;
                                        });
                                    });
                                }
                                self.documents = self.documents.concat(documentsGroup);
                                // always remove I9 because we have it in a different feature "HARRI-33574: Upload I-9 Flow"
                                spliceDocument([self.DOCUMENT_TYPE.I9]);
                                if (self.documents[0]) {
                                    self.data.newDocs = [
                                        {
                                            'docType': self.documents[0].code
                                        }
                                    ];
                                }
                                scope.$digest();
                            },
                            function(err) {
                                console.error(err);
                            });
                })
                .catch(function (reason) {
                    console.error("Can't load user permissions", reason);
                });
        }
    };

    //saving the form
    self.save = function () {
        var defer = $q.defer();

        if (self.validator.validate()) {
            //put custom validation on docs
            if(validateFormDocs()){
                var promisses = [];

                for(var i in self.data.newDocs){
                    if(self.data.newDocs[i].selectedFile && !self.data.newDocs[i].isSaved){
                        promisses.push(uploadDocument(self.data.newDocs[i]));
                    }
                }

                $q.all(promisses).then(function(resolutions){

                    defer.resolve(self.OBIdObj);

                },function(errors){

                    console.error(errors);
                    defer.reject({code: "save", message: "Form didn't save"});

                })

            }else{

                //show error
                self.data.errors.notValidDocs = true;
                //reject the form
                defer.reject({code: "validation", message: "Form didn't validate"});
            }
        }else {
            defer.reject({code: "validation", message: "Form didn't validate"});
        }

        return defer.promise;
    };

    //add new document
    self.addNewDocument = function(){
        const hasOfferDoc = self.documents.some(doc => doc.code === self.DOCUMENT_TYPE.OFFER);
        self.data.newDocs.push({
            'docType': self.canEditOffer && self.canEditOfferDescription && !self.excludeOfferColumn && hasOfferDoc ? self.DOCUMENT_TYPE.OFFER : self.documents[0].code
        });
    };

    //delete loaded doc
    self.deleteLoadedDoc = function(docIndex){
        var removedDoc = ar_delete(self.data.newDocs, docIndex);
        if(!self.data.newDocs.length){
            self.addNewDocument();
        }
    }

    //load Doc from File
    self.loadDocFromFile = function(doc,files) {
        if (files && files[0]) {
            var fileSize = new HFileSize(files[0]).type('docs');
            if(!fileSize.allowed()){
                fileSize.showError();
            }
            else{
                var fileType = Utils.getFileType(files[0]);
                if ((fileType.indexOf("image/") > -1 && fileType.indexOf("image/gif") == -1) || fileType.indexOf("/pdf") > -1) {
                    doc.selectedFile = files[0];
                }
                else {
                    hAlert($filter("translate")("Invalid file type") + ": " + files[0].name, $filter("translate")("Attachment should be image or PDF file."))
                }
            }
        }
    }


    //Delete Document
    self.deleteDocument = function(doc){

        doc.deleted = true;

        OnBoardingAPI.deleteDocument(doc.id).then(function(res){

            var docIndex = -1;
            for(var i in self.OBIdObj.documents){
                if(self.OBIdObj.documents[i].id == doc.id){
                    docIndex = i;
                }
            }
            if(docIndex !== -1){
                var removedDoc =  ar_delete(self.OBIdObj.documents,docIndex);
                trigger("delete-document", removedDoc);
            }

            //sync scope
            scope.$digest();

        }, function (err) {
            doc.deleted = false;
            console.error(err);
        });
    }



    //upload Docs
    var uploadDocument = function(doc){

        var defer = $q.defer();

        //mark as uploading
        doc.isUploading = true;

        //upload
        Upload.upload({
            url: publicConfiguration.OnboardingServerBaseURL + 'document_upload',
            withCredentials: true,
            headers: {},
            method: "PUT",
            data: {
                prospect_id : self.OBIdObj.id,
                document_lookup_code: doc.docType,
            },
            file: doc.selectedFile
        }).progress(function (evt) {
            var uploaded = evt.loaded || 0;
            var total = evt.total;
            doc.uploadProgress = 100 * uploaded/total;
        }).success(function (data, status, headers, config) {
            //mark uploading finished
            doc.isUploading = false;
            doc.uploadProgress = 0;

            //defer of resolve
            if (data.status_code == 200) {
                //mark it as saved
                doc.isSaved = true;
                //resolve
                defer.resolve(doc);
            }
            else {
                //upload error
                doc.uploadingError = data.data;
                //log error
                console.error(data);
                //reject doc
                defer.reject(doc);
            }
        }).error(function (reason) {
            //upload error
            doc.uploadingError = reason.data;
            //done uploading
            doc.isUploading = false;
            //log error
            console.error(reason);
            //reject doc
            defer.reject(doc);
        });

        return defer.promise;
    }


    //validate docs for form if there is on doc then it's valid
    var validateFormDocs = function(){
       if(self.OBIdObj.documents && self.OBIdObj.documents.length>0){
           return true;
       }

       for(var i in self.data.newDocs){
           if(self.data.newDocs[i].selectedFile){
               return true;
           }
       }

        return false;
    }


    //destroy form
    self.destroy = function() {
        self.data = {};
        self.data.errors = {};
        delete self.documents;
        self.OBIdObj = null;
    };

        //load data or init
    var init = function(){
        //load data
        self.load();
    }

    init();
}
